import { ClaimType, ListType } from '../types/common.types';

export const Status: ListType[] = [
	{ keyId: 1, name: 'Active' },
	{ keyId: 2, name: 'Active soon' },
	{ keyId: 3, name: 'Ends soon' },
	{ keyId: 4, name: 'Inactive' },
];

export const LogoClaimMaterials: string[] = [
	'0297',
	'0230',
	'0881',
	'0426',
	'0758',
	'2012',
	'2024',
	'0757',
	'0760',
	'0761',
	'0762',
	'0771',
	'0770',
	'2127',
	'0449',
	'0380',
];

export const ClaimsThreshold: ClaimType[] = [
	{ materialId: '0031', threshold: 20 },
	{ materialId: '0059', threshold: 30 },
	{ materialId: '0308', threshold: 30 },
	{ materialId: '0321', threshold: 70 },
	{ materialId: '0372', threshold: 30 },
	{ materialId: '0416', threshold: 5 },
	{ materialId: '0436', threshold: 70 },
	{ materialId: '0803', threshold: 30 },
	{ materialId: '0875', threshold: 70 },
	{ materialId: '0879', threshold: 70 },
	{ materialId: '2064', threshold: 1 },
	{ materialId: '0380', threshold: 30 },
];
